import { Field } from 'formik';
import { useState } from 'react'
import MedicalFileUploadBtn from './MedicalFileUploadBtn';
import { ReactComponent as RemoveIcon } from '../../assets/icons/RemoveIcon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/EditIcon.svg';
import { ReactComponent as MoveIcon } from '../../assets/icons/MoveIcon.svg';
import { TextInput, RedesignedFileUpload } from '../index';
import { validationFilesFunc } from '../../utils/helper';

const MedicalProviderList = ({providerType,formikValues,selectedTiffIndex,setFieldValue,setShowReorderSec,setFileErrorList}) => {
    const [isDisableEditSaveBtn, setDisableEditSaveBtn] = useState(false); // if value exist the disable save button 
    const [editProviderIndex, setEditProviderIndex] = useState(null); // set index which should edit
    const [localProviderNames, setLocalProviderNames] = useState(null); // temprary store value only update when user click on save

    const deleteProvider = (indexToDelete) => {
        const updatedFiles = formikValues?.medicalFiles[selectedTiffIndex]?.[providerType].medicalRecords.filter((_, idx) => idx !== indexToDelete);
        setFieldValue(`medicalFiles[${selectedTiffIndex}].[${providerType}].medicalRecords`, updatedFiles);
    };

    const handleCancelProviderName = () => {
        setLocalProviderNames(null)
        setEditProviderIndex(null)
    };

    const handleSaveProviderName = (index) => {
        if(localProviderNames != null){ // if user not update value and directly enter the value
            setFieldValue(`medicalFiles[${selectedTiffIndex}[${providerType}].medicalRecords.${index}.providerName`,localProviderNames);
        }
        handleCancelProviderName();
    };

    const removeMedicalFile = (providerIndex, fileIndex) => {
        const recordPath = `medicalFiles[${selectedTiffIndex}].[${providerType}].medicalRecords[${providerIndex}].source`;
        const updatedFiles = formikValues?.medicalFiles?.[selectedTiffIndex]?.[providerType]?.medicalRecords?.[providerIndex]?.source?.filter(
            (_, idx) => idx !== fileIndex
        ) || [];
        if (formikValues?.medicalFiles?.[selectedTiffIndex]?.[providerType]?.medicalRecords?.[providerIndex]) {
            formikValues.medicalFiles[selectedTiffIndex][providerType].medicalRecords[providerIndex].source = updatedFiles;
        }
        setFieldValue(recordPath, updatedFiles);
    };

    

    const onOtherFilesUpload = async (files, providerIndex) => {
        const newFiles = Array.from(files.file);
        const validFiles = await validationFilesFunc(newFiles,setFileErrorList);
        const recordPath = `medicalFiles[${selectedTiffIndex}][${providerType}].medicalRecords[${providerIndex}].source`;
        const existingRecords = formikValues?.medicalFiles?.[selectedTiffIndex]?.[providerType]?.medicalRecords?.[providerIndex]?.source || [];
        const combinedArr = [...existingRecords, ...validFiles];
        const updatedRecords = [...new Map(combinedArr.map(item => [item.name, item])).values()];
        setFieldValue(recordPath, updatedRecords);
    };

    const onProviderNameChange = (e,index)=>{
        const filteredValue =  formikValues.medicalFiles[selectedTiffIndex][providerType].medicalRecords.find((obj,objIndex)=>{
            if(objIndex === index){ return false}
            return obj.providerName.trim().toLowerCase() === e.target.value.trim().toLowerCase()
        });
        if(filteredValue){
            setDisableEditSaveBtn(true)    
        }else{
            setDisableEditSaveBtn(false)
        }
        setLocalProviderNames(e.target.value)
    }

    return (
        <>
            {formikValues?.medicalFiles[selectedTiffIndex]?.[providerType].medicalRecords?.map((entry, index) => (
                <div key={index} className='report-section  position-relative file-input mb-4'>
                    <div className="d-flex align-items-center gap-4">
                        <div className="w-100">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className="report-btn w-100">
                                    <div className="d-flex align-items-center gap-2">
                                        {editProviderIndex === index ?  <div className='show-item d-flex gap-2'>
                                                <Field name={`medicalFiles[${selectedTiffIndex}].[${providerType}].medicalRecords.${index}.providerName`}
                                                    value={localProviderNames !=null ? localProviderNames : formikValues.medicalFiles[selectedTiffIndex][providerType].medicalRecords[index].providerName}
                                                    onChange={(e) => {onProviderNameChange(e,index)}}
                                                    component={TextInput} />
                                                    <button type="button" className="btn btn-theme" onClick={() => handleCancelProviderName(index)}>Cancel</button>
                                                    <button type="button" disabled={isDisableEditSaveBtn} className="btn btn-theme" onClick={() => handleSaveProviderName(index)}>{isDisableEditSaveBtn ? "Provider Name is Already Exist"  : "Save"}</button>
                                            </div> 
                                            : 
                                            <>
                                                <span className="card-title">{entry?.providerName}</span>
                                                <EditIcon onClick={() => {
                                                    setLocalProviderNames(null);
                                                    setDisableEditSaveBtn(false);
                                                    setEditProviderIndex(index); 
                                                }} />
                                            </>
                                        }
                                    </div>
                                    <RemoveIcon className='show-item' style={{ cursor: 'pointer' }} onClick={() => {
                                        setLocalProviderNames(null);
                                        setEditProviderIndex(null)
                                        deleteProvider(index)}
                                    } />
                                </div>
                            </div>
                            {entry.source.map((file, fileIndex) => (
                                <div key={fileIndex} className="report-item show-item">
                                    <div className="d-flex align-items-center">
                                        <MoveIcon className='me-2' />
                                        {file.name}
                                    </div>
                                    <button type='button' className="delete-btn" onClick={(e) => removeMedicalFile(index, fileIndex)}>
                                        <i className="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="mt-4 d-flex align-items-center justify-content-end">
                        <button className="btn btn-theme btn-white-blue me-2 show-item" type='button' onClick={() => setShowReorderSec((preVal=>({...preVal,[providerType]:true})))}>Reorder Providers</button>
                        <MedicalFileUploadBtn/>
                    </div>
                    <Field name="medicalBills" component={RedesignedFileUpload} multiplefileUpload={true} onFileSelected={(files) => onOtherFilesUpload(files, index)} documentName='MedicalBills' accept="application/pdf" />
                </div>
            ))}
        </>
    )
}

export default MedicalProviderList;